/** US storefront linear inches as whole + reduced fraction (nearest 1/16). */

const MAX_DENOMINATOR = 16;

const gcd = (a: number, b: number): number => {
  let x = Math.abs(a);
  let y = Math.abs(b);

  while (y !== 0) {
    const next = y;
    y = x % y;
    x = next;
  }

  return x || 1;
};

export const formatInchAsFraction = (inches: number): string => {
  if (!Number.isFinite(inches)) {
    return '';
  }

  const sign = inches < 0 ? '-' : '';
  const abs = Math.abs(inches);
  let whole = Math.floor(abs + 1e-9);
  let sixteenths = Math.round((abs - whole) * MAX_DENOMINATOR);

  if (sixteenths >= MAX_DENOMINATOR) {
    whole += 1;
    sixteenths = 0;
  }

  if (sixteenths === 0) {
    return `${sign}${whole}`;
  }

  let numerator = sixteenths;
  let denominator = MAX_DENOMINATOR;
  const divisor = gcd(numerator, denominator);
  numerator /= divisor;
  denominator /= divisor;

  const fraction = `${numerator}/${denominator}`;

  if (whole === 0) {
    return `${sign}${fraction}`;
  }

  return `${sign}${whole} ${fraction}`;
};
